import common from '../common';

export default {
  jpath: ['spectra', 'cyclicVoltammetry'],
  find: common.basenameFind,
  getProperty: common.getTargetProperty,
  process: common.getMetaFromJcamp,
};
